module.exports = __webpack_public_path__ + "static/img/12-北京市第十八中学(左安门校区)1.e76c76b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/12-北京市第十八中学(左安门校区)1.png
// module id = earC
// module chunks = 0